import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ModalService } from '@shared/services/modal.service';
import { SleipModalContent } from '@shared/models/modal-config.model';
import { delay, startWith, tap } from 'rxjs';
import { SLEIP_MODAL_CONTENT } from '@shared/injection-tokens/injection-tokens';

@Component({
    selector: 'app-modal',
    imports: [CommonModule, MatIconModule],
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  constructor(
    protected modalService: ModalService,
    @Inject(SLEIP_MODAL_CONTENT) public modalContent: SleipModalContent
  ) {}

  footerActionsTemplate!: TemplateRef<Element> | null;

  ngOnInit() {
    this.modalService.footerActionsTemplate$
      .pipe(
        startWith(null),
        delay(0),
        tap((template) => (this.footerActionsTemplate = template))
      )
      .subscribe();
  }

  get showModalHeaderSection() {
    return !this.modalContent.hideCloseButton || this.modalContent.title;
  }
}
